export default __webpack_public_path__ + "static/kampagne-mwb-bade0d86dd8adde9306e04ae677a6fd6.jpg";